import React from 'react';

import { graphql, withApollo, compose } from 'react-apollo';
import { Upload, Row, Col, Button, Input, Select, message } from 'antd/lib';
import { Form } from '@ant-design/compatible';
import * as Icons from '@ant-design/icons';
import Loading from '../../common/Loading';

import insertarDocumentoPDF from '../../../graphql/mutations/documentos/insertarDocumentoPDF.graphql';

@compose(
  graphql(insertarDocumentoPDF, {
    name: 'insertarDocumentoPDF',
  })
)
class AddDocumentos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      titulo: '',
      tipoDoc: undefined,
      file: [],
      loaded: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    // console.log('ESTADO: ', this.state);
    if (this.state.file.length > 0 && this.state.tipoDoc) {
      this.props
        .insertarDocumentoPDF({
          variables: {
            documento: {
              titulo: this.state.titulo,
              tipoDocumento: this.state.tipoDoc,
            },
            archivo: this.state.file[0],
          },
        })
        .then(res => {
          // console.log('Respuesta insert doc', res);
          message.success('Documento cargado correctamente');
          this.setState({
            titulo: '',
            tipoDoc: undefined,
            file: [],
            loaded: false,
          });
        })
        .catch(err => {
          console.log('ERROR AL SUBIR EL DOCUMENTO');
          console.log(err);
        });
    } else {
      message.error('No ha llenado todos los campos');
    }
  }

  render() {
    const uploadProps = {
      accept: 'application/pdf',
      listType: 'picture',

      beforeUpload: file => {
        const isPDF = file.type === 'application/pdf';
        if (!isPDF) {
          message.error(`${file.name} no es un archivo PDF`);
        }
        // TRANSFORMAR ARCHIVO
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e => {
          file.base64 = e.target.result;
        };

        this.setState({ file: [file], loaded: true });
        return false;
      },
      fileList: this.state.file,
      onRemove: file => {
        this.setState({ file: [], loaded: false });
      },
    };

    return (
      <div>
        <h2 style={{ textAlign: 'center', marginTop: 20 }}>
          Agregar Documentos
        </h2>
        <Form encType="multipart/form-data" onSubmit={this.handleSubmit}>
          <Row>
            <Col span={10}>
              <div className="inputs">
                <h3>Titulo: </h3>
                <Input
                  required
                  id="titulo"
                  value={this.state.titulo}
                  placeholder="Ingrese el titulo del documento a subir"
                  onChange={e =>
                    this.setState({
                      titulo: e.target.value,
                    })
                  }
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={4}>
              <div className="inputs">
                <h3>Tipo Documento: </h3>
                <Select
                  required
                  id="tipoDoc"
                  value={this.state.tipoDoc}
                  placeholder="Seleccione el tipo de document"
                  onSelect={valor =>
                    this.setState({
                      tipoDoc: valor,
                    })
                  }
                >
                  <Select.Option value="circular">Circular</Select.Option>
                  <Select.Option value="comunicado">Comunicado</Select.Option>
                  <Select.Option value="resolucion">Resolucion</Select.Option>
                  <Select.Option value="manual">
                    Manual / Instructivo
                  </Select.Option>
                </Select>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div className="inputs">
                <h3>Archivo: </h3>
                <Upload {...uploadProps} required>
                  <Button disabled={this.state.loaded}>
                    <Icons.UploadOutlined />
                    Seleccionar Documento PDF
                  </Button>
                </Upload>
              </div>
            </Col>
          </Row>
          <Row>
            <Col style={{ margin: 'auto' }}>
              <Button type="primary" htmlType="submit">
                Guardar Documento
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

export default withApollo(AddDocumentos);
